/**
 * Utilitaires pour la gestion des dates dans les modaux de validation
 */

/**
 * Formate une date en chaîne JJ/MM/AAAA
 * @param {Date} date - La date à formater
 * @returns {string} La date formatée ou chaîne vide si invalide
 */
export const formatDateToString = (date) => {
  if (!date) return '';
  const day = ('0' + date.getDate()).slice(-2);
  const month = ('0' + (date.getMonth() + 1)).slice(-2);
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

/**
 * Formate une saisie utilisateur en ajoutant automatiquement les slashes
 * @param {string} value - La valeur saisie par l'utilisateur
 * @returns {string} La valeur formatée avec les slashes
 */
export const formatDateInput = (value) => {
  // Retirer tous les caractères non numériques
  const numbers = value.replace(/\D/g, '');
  
  // Limiter à 8 chiffres (JJMMAAAA)
  const limitedNumbers = numbers.slice(0, 8);
  
  // Ajouter les slashes automatiquement
  let formatted = limitedNumbers;
  if (limitedNumbers.length > 2) {
    formatted = limitedNumbers.slice(0, 2) + '/' + limitedNumbers.slice(2);
  }
  if (limitedNumbers.length > 4) {
    formatted = limitedNumbers.slice(0, 2) + '/' + limitedNumbers.slice(2, 4) + '/' + limitedNumbers.slice(4);
  }
  
  return formatted;
};

/**
 * Convertit une chaîne de date formatée (JJ/MM/AAAA) en objet Date
 * @param {string} dateText - La date au format JJ/MM/AAAA
 * @returns {Date|null} L'objet Date ou null si invalide
 */
export const parseDateText = (dateText) => {
  if (!dateText || dateText.length !== 10) return null;
  const parts = dateText.split('/');
  if (parts.length !== 3) return null;
  
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1; // Les mois sont 0-indexés
  const year = parseInt(parts[2], 10);
  
  if (isNaN(day) || isNaN(month) || isNaN(year)) return null;
  if (day < 1 || day > 31 || month < 0 || month > 11 || year < 1900 || year > 2100) return null;
  
  const date = new Date(year, month, day);
  // Vérifier que la date est valide (gère les cas comme 31/02)
  if (date.getDate() !== day || date.getMonth() !== month || date.getFullYear() !== year) {
    return null;
  }
  return date;
};

/**
 * Formate une date de naissance à partir d'un objet user
 * @param {Date|string} birthday - La date de naissance
 * @returns {string} La date formatée
 */
export const formatBirthday = (birthday) => {
  if (!birthday) return '';
  
  let birthDate = new Date(birthday);
  if (isNaN(birthDate.getTime())) {
    // Si ce n'est pas un format de date valide, essayer JJ-MM-AAAA
    const dateParts = String(birthday).split('-');
    if (dateParts.length === 3) {
      birthDate = new Date(dateParts[2] + '-' + dateParts[1] + '-' + dateParts[0]);
    }
  }
  
  if (isNaN(birthDate.getTime())) return '';
  
  return formatDateToString(birthDate);
};
